import noTableData from "../assets/svg/icons/no-table-data.svg";

const NoTableData = ({ text = "No Data Available" }) => {
  return (
    <div className="bl-table-empty tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-py-6">
      <img src={noTableData} alt="No data available" style={{ width: 160, height: "auto" }} />
      <div className="tw-text-sm tw-font-medium tw-text-slate-500 tw-mt-1">{text}</div>
    </div>
  );
};

export default NoTableData;
